import React, {useState, useContext} from 'react';
import styled, { css } from 'styled-components';

import Logo from '../components/Logo';

import { GlobalContext } from '../contexts/GlobalContext';

const FlexContainer = styled.div`
    display: flex;
    justify-content: space-between;
    padding-left: 60px;
    padding-right: 60px;
    padding-top: 45px;

    // outline: 1px dotted red;
`;


const NavbarUl = styled.ul`
    list-style-type: none;
    align-self: center;
    transform: translateY(10px);

    @media screen and (max-width: 805px) {
        display: none;
        margin: 0;
        align-items: center;

        ${props => props.openMenu && css`
        background: #fff;
        display: flex;
        flex-direction: column;
        width: 50vw;
        height: 100vh;
        max-height: 100vh;
        justify-content: space-between;
        outline: 1px solid #E2E2E2;
        position: absolute;
        top: 0;
        right: 0;
        padding: 0;
        padding-top: 20vh;
        padding-bottom: 20vh;
        z-index: 1;
        `
    }

    @media screen and (max-width: 805px) {
        width: 100vw;
    }
`;

const NavbarLi = styled.li`
    color: rgba(29, 89, 155, 1);
    display: inline;
    font-family: Poppins;
    font-size: 18px;
    padding-left: 57px;
    font-weight: ${props => props.selected ? '800' : 'normal'};
    text-decoration:  ${props => props.selected ? 'underline' : 'none'};

    :hover {
        cursor: pointer;
        color: rgba(29, 89, 155, 0.6);
    }
`;


const NavbarMenu = styled.div`
    color: rgba(29, 89, 155, 1);
    font-family: Poppins;
    font-size: 18px;
    transform: translateY(35px);
    height: 100%;

    :hover {
        cursor: pointer;
    }

    @media screen and (min-width: 805px) {
        display: none;
    }

    @media screen and (max-width: 804px) {
        ${props => props.openMenu && css`
            z-index: 2;
        `
    }
`;

const NavBar = (props) => {

    const [navSelection, setNavSelection] = useState('employees');
    const [openMenu, setOpenMenu] = useState(false);

    const [context, setContext] = useContext(GlobalContext);

    const employeesClick = () => {
        props.employeesCb();
        setNavSelection('employees');
        setOpenMenu(false);

        setContext( (p) => {
            return {...p, selectedCells: []}
        });
    }

    const positionsClick = () => {
        props.positionsCb();
        setNavSelection('positions');
        setOpenMenu(false);
    }

    const qualificationsClick = () => {
        props.qualificationsCb();
        setNavSelection('qualifications');
        setOpenMenu(false);
    }

    const schedulesClick = () => {
        props.schedulesCb();
        setNavSelection('schedules');
        setOpenMenu(false);

        setContext( (p) => {
            return {...p, selectedCells: []}
        });
        
    }

    const saveStateClick = () => {
        props.saveStateCb();
        setNavSelection('save');
        setOpenMenu(false);
    }

    const onMobileMenuClick = () => {
        setOpenMenu(!openMenu);

    }

    return (
        <FlexContainer>
            <Logo />

            <NavbarMenu  openMenu={openMenu} onClick={onMobileMenuClick}>
                {openMenu ? 'Close Menu' : 'Menu'}
            </NavbarMenu>

            <NavbarUl openMenu={openMenu} role='navigation'>
                <NavbarLi role='link' selected={navSelection === 'employees'} onClick={employeesClick}>Employees</NavbarLi>
                <NavbarLi role='link'  selected={navSelection === 'positions'} onClick={positionsClick}>Positions</NavbarLi>
                <NavbarLi role='link'  selected={navSelection === 'qualifications'} onClick={qualificationsClick}>Qualifications</NavbarLi>
                <NavbarLi role='link' selected={navSelection === 'schedules'} onClick={schedulesClick}>Schedules</NavbarLi>
                {/*<NavbarLi role='link' selected={navSelection === 'save'} onClick={saveStateClick}>Save</NavbarLi>*/}
            </NavbarUl>
        </FlexContainer>
    );
}


export default NavBar;